import { cn } from "@/lib/utils";
import { Quote } from 'lucide-react';

export function TrustedBy() {
  const logos = [
    { src: "/images/SnapInc.jpg", alt: "Snap Inc" },
    { src: "/images/Pfizer.png", alt: "Pfizer" },
    { src: "/images/GS.png", alt: "Goldman Sachs" },
    { src: "/images/Alphabet.png", alt: "Alphabet" },
    { src: "/images/Adecco.png", alt: "Adecco" },
    { src: "/images/Airbnb.svg", alt: "Airbnb" },
    { src: "/images/Microsoft.svg", alt: "Microsoft" }
  ];

  // Testimonial quotes from trusted customers
  const testimonialQuotes = [
    {
      quote: "We've reduced our time-to-hire by 68% since implementing TopMatchTalent.",
      author: "Sarah Johnson",
      title: "Head of Talent Acquisition, Snap Inc.",
      logo: "/images/SnapInc.jpg"
    },
    {
      quote: "The customized interview plans have helped us make more informed hiring decisions consistently.",
      author: "Michael Chen",
      title: "Technical Recruiting Manager, Alphabet",
      logo: "/images/Alphabet.png"
    }
  ];

  return (
    <div className="bg-background/50 border-y border-border/30 py-14 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className={cn(
              "text-base font-semibold tracking-wider uppercase mb-2",
              "text-primary"
          )}>
            TRUSTED BY INDUSTRY LEADERS
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Join 500+ companies using TopMatchTalent to optimize their hiring process
          </p>
        </div>

        {/* Featured Testimonial Quotes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
          {testimonialQuotes.map((item, i) => (
            <div key={i} className="bg-card border border-border/50 rounded-lg p-6 shadow-sm">
              <div className="flex items-start mb-4">
                <div className="text-primary">
                  <Quote className="h-6 w-6 text-primary/60" />
                </div>
                <p className="ml-2 text-foreground italic">{item.quote}</p>
              </div>
              <div className="flex items-center">
                <img 
                  src={item.logo} 
                  alt={item.author} 
                  className="w-8 h-8 object-contain rounded mr-3" 
                />
                <div>
                  <p className="font-medium text-sm">{item.author}</p>
                  <p className="text-xs text-muted-foreground">{item.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Logo Cloud - with improved styling */}
        <div className="grid grid-cols-3 gap-y-8 gap-x-10 sm:grid-cols-4 lg:grid-cols-7 items-center">
          {logos.map((logo, i) => (
            <div key={i} className="col-span-1 flex justify-center">
              <img 
                className={cn(
                  "h-7 sm:h-8 w-auto object-contain",
                  "opacity-70 grayscale contrast-90",
                  "hover:opacity-100 hover:grayscale-0 hover:contrast-100",
                  "transition-all duration-300 ease-in-out"
                )}
                src={logo.src} 
                alt={logo.alt}
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {/* Social Proof Counters */}
        <div className="flex flex-wrap justify-center gap-x-12 sm:gap-x-16 gap-y-4 mt-12 text-center">
          <div>
            <p className="font-bold text-2xl sm:text-3xl text-primary">500+</p>
            <p className="text-xs text-muted-foreground uppercase tracking-wider">Companies</p>
          </div>
          <div>
            <p className="font-bold text-2xl sm:text-3xl text-primary">12,000+</p>
            <p className="text-xs text-muted-foreground uppercase tracking-wider">Candidates Matched</p>
          </div>
          <div>
            <p className="font-bold text-2xl sm:text-3xl text-primary">97%</p>
            <p className="text-xs text-muted-foreground uppercase tracking-wider">Customer Satisfaction</p>
          </div>
          <div>
            <p className="font-bold text-2xl sm:text-3xl text-primary">32</p>
            <p className="text-xs text-muted-foreground uppercase tracking-wider">Countries</p>
          </div>
        </div>
      </div>
    </div>
  );
}